import { render, staticRenderFns } from "./lazada-logs.vue?vue&type=template&id=09f87984&"
import script from "./lazada-logs.vue?vue&type=script&lang=js&"
export * from "./lazada-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports